<template>
  <div class="modal-overlay">
    <div class="mmodal-content" style="max-width: 80vw">
      <div class="modal-header">
        <h3>{{ editingRecord ? "Edit" : "Add" }} Mental Health Assessment</h3>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>
      <div class="modal-body">
        <form @submit.prevent="saveRecord">
          <div class="form-grid">
            <div class="form-group">
              <label>Date Assessed *</label>
              <input type="datetime-local" v-model="form.assessed_at" required class="form-control" />
            </div>

            <div class="form-group full-width">
              <label>Presenting Complaint</label>
              <textarea v-model="form.presenting_complaint" class="form-control" rows="2"></textarea>
            </div>

            <div class="form-group ">
              <label>Appearance & Behaviour</label>
              <input type="text" v-model="form.appearance_behaviour"  class="form-control" />
            </div>

            <div class="form-group ">
              <label>Mood</label>
              <input type="text" v-model="form.mood"  class="form-control" />
            </div>

            <div class="form-group ">
              <label>Affect</label>
              <input type="text" v-model="form.affect"  class="form-control" />
            </div>

            <div class="form-group ">
              <label>Speech</label>
              <input type="text" v-model="form.speech"  class="form-control" />
            </div>

            <div class="form-group ">
              <label>Cognition</label>
              <input type="text" v-model="form.cognition"  class="form-control" />
            </div>

            <div class="form-group ">
              <label>Insight</label>
              <select v-model="form.insight"  class="form-control">
                <option value="">Select</option>
                <option value="Good">Good</option>
<option value="Partial">Partial</option>
<option value="Poor">Poor</option>
              </select>
            </div>

            <div class="form-group ">
              <label>Judgement</label>
              <input type="text" v-model="form.judgement"  class="form-control" />
            </div>

            <div class="form-group full-width">
              <label>Thought Form & Content</label>
              <textarea v-model="form.thought_form_content" class="form-control" rows="2"></textarea>
            </div>

            <div class="form-group full-width">
              <label>Perception</label>
              <textarea v-model="form.perception" class="form-control" rows="2"></textarea>
            </div>

            <div class="form-group ">
              <label>Clinician-Assessed Risk Level</label>
              <select v-model="form.risk_level"  class="form-control">
                <option value="">Select</option>
                <option value="None identified">None identified</option>
<option value="Low">Low</option>
<option value="Moderate">Moderate</option>
<option value="High">High</option>
              </select>
            </div>

            <div class="form-group full-width">
              <label>Risk Notes</label>
              <textarea v-model="form.risk_notes" class="form-control" rows="2"></textarea>
            </div>

            <div class="form-group full-width">
              <label>Safety Plan</label>
              <textarea v-model="form.safety_plan" class="form-control" rows="2"></textarea>
            </div>

            <div class="form-group full-width">
              <label>Provisional Diagnosis</label>
              <textarea v-model="form.provisional_diagnosis" class="form-control" rows="2"></textarea>
            </div>

            <div class="form-group full-width">
              <label>Management Plan</label>
              <textarea v-model="form.management_plan" class="form-control" rows="2"></textarea>
            </div>

            <div class="form-group">
              <label class="checkbox-label">
                <input type="checkbox" v-model="form.referral_made" />
                Referral made
              </label>
            </div>

            <div class="form-group ">
              <label>Referred To</label>
              <input type="text" v-model="form.referred_to"  class="form-control" />
            </div>

            <div class="form-group full-width">
              <label>Notes</label>
              <textarea v-model="form.notes" class="form-control" rows="2"></textarea>
            </div>

            <div class="form-group ">
              <label>Assessed By</label>
              <input type="text" v-model="form.assessed_by"  class="form-control" />
            </div>
          </div>

          <div class="modal-actions">
            <button type="button" class="btn btn-secondary" @click="closeModal">Cancel</button>
            <button type="submit" class="btn btn-primary" :disabled="saving">
              {{ saving ? "Saving..." : (editingRecord ? "Update" : "Save") + " Assessment" }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../../api/apiIndex";

export default {
  name: "MentalHealthAssessmentModal",
  props: {
    visitId: { type: [Number, String], default: null },
    editRecord: { type: Object, default: null },
  },
  data() {
    return {
      saving: false,
      editingRecord: null,
      form: this.emptyForm(),
    };
  },
  created() {
    if (this.editRecord) {
      this.editingRecord = this.editRecord;
      this.form = {
        ...this.emptyForm(),
        ...this.editRecord,
        assessed_at: this.toLocalDateTime(this.editRecord.assessed_at),
      };
    }
  },
  methods: {
    emptyForm() {
      return {
        assessed_at: this.toLocalDateTime(new Date()),
        presenting_complaint: "",
        appearance_behaviour: "",
        mood: "",
        affect: "",
        speech: "",
        cognition: "",
        insight: "",
        judgement: "",
        thought_form_content: "",
        perception: "",
        risk_level: "",
        risk_notes: "",
        safety_plan: "",
        provisional_diagnosis: "",
        management_plan: "",
        referral_made: false,
        referred_to: "",
        notes: "",
        assessed_by: ""
      };
    },
    toLocalDateTime(value) {
      if (!value) return "";
      const d = new Date(value);
      if (isNaN(d.getTime())) return "";
      const pad = (n) => String(n).padStart(2, "0");
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },
    closeModal() {
      this.$emit("close");
    },
    async saveRecord() {
      this.saving = true;
      try {
        const payload = { ...this.form, visit_id: this.visitId };
        let response;
        if (this.editingRecord) {
          response = await generalApiRequest(`mental_health_assessments/${this.editingRecord.id}`, "PUT", payload, 1);
        } else {
          response = await generalApiRequest("mental_health_assessments", "POST", payload, 1);
        }
        if (response.success) {
          this.$emit("saved", response.data);
          this.closeModal();
        } else {
          alert(response.message || "Failed to save record");
        }
      } catch (error) {
        console.error("Error saving record:", error);
        alert("An error occurred while saving");
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style scoped>
.modal-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 1000; }
.mmodal-content { background: white; border-radius: 10px; max-height: 90vh; overflow-y: auto; display: flex; flex-direction: column; }
.modal-header { padding: 20px; background: linear-gradient(135deg, #4c51bf 0%, #34399b 100%); color: white; display: flex; justify-content: space-between; align-items: center; }
.modal-header h3 { margin: 0; font-size: 20px; }
.close { background: rgb(233, 22, 22); border: 1px solid rgb(182, 178, 178); font-size: 1.5rem; color: white; line-height: 1; cursor: pointer; }
.modal-body { padding: 30px; overflow-y: auto; flex-grow: 1; }
.form-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; margin-bottom: 20px; }
.form-group { margin-bottom: 15px; }
.form-group.full-width { grid-column: 1 / -1; }
.form-group label { display: block; margin-bottom: 5px; font-weight: 600; color: #495057; }
.checkbox-label { display: flex !important; align-items: center; gap: 8px; margin-top: 28px; }
.form-control { width: 100%; padding: 10px; border: 1px solid #ddd; border-radius: 5px; font-size: 14px; }
.modal-actions { display: flex; justify-content: flex-end; gap: 15px; }
.btn { padding: 10px 25px; border: none; border-radius: 5px; cursor: pointer; font-weight: 600; }
.btn-secondary { background: #6c757d; color: white; }
.btn-secondary:hover { background: #5a6268; }
.btn-primary { background: #34399b; color: white; }
.btn-primary:hover { opacity: 0.9; }
.btn-primary:disabled { opacity: 0.6; cursor: not-allowed; }
@media (max-width: 1200px) { .form-grid { grid-template-columns: repeat(2, 1fr); } }
@media (max-width: 768px) { .form-grid { grid-template-columns: 1fr; } }
</style>
